import AlertExpiredPaymentMethod from './alert-expired-payment-method-container';

export default AlertExpiredPaymentMethod;
